import { render, staticRenderFns } from "./ChangePasswordPage.vue?vue&type=template&id=19615bef&scoped=true&"
import script from "./ChangePasswordPage.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordPage.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordPage.vue?vue&type=style&index=0&id=19615bef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19615bef",
  null
  
)

export default component.exports